import { create } from 'zustand';

import { KeyImage } from '@/api';

import { KeyImageLabelsState } from './use-key-image-labels.model';

export const useKeyImageLabelsStore = create<KeyImageLabelsState>((set) => ({
  addKeyImageLabel: (label: KeyImage) => {
    set((state) => ({
      keyImageLabels: [...state.keyImageLabels, label],
    }));
  },

  keyImageLabels: [],

  removeLabelsForRenderedSummary: (renderedSummaryUuid: string) => {
    set((state) => ({
      keyImageLabels: state.keyImageLabels.filter(
        (label) => label.renderedSummaryUuid !== renderedSummaryUuid,
      ),
    }));
  },

  setKeyImageLabels: (keyImageLabels: KeyImage[]) => set({ keyImageLabels }),

  updateKeyImageLabel: (updatedLabel: KeyImage) => {
    set((state) => {
      const updatedLabels = state.keyImageLabels.map((item) => ({
        ...item,
        label: item.uuid === updatedLabel.uuid ? updatedLabel.label : item.label,
      }));

      return {
        keyImageLabels: updatedLabels,
      };
    });
  },
}));
